import { useChatContext } from './ChatContext';

const useRequestParameters = () => {
    const { requestParameters, setRequestParameters } = useChatContext();
    return { requestParameters, setRequestParameters };
};

export default useRequestParameters;
